export function selectedShopKey(userId) {
  return userId ? `annoncen.selectedShop.${userId}` : "";
}

export function findSelectedShop(shops, storedShopId) {
  return shops.find((shop) => shop.id === storedShopId) || shops[0] || null;
}
